import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Icon,
  Loading,
  Row,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { Field } from 'react-final-form';
import css from '../../style.css';

function GeneratorCard({ pristine, submitting, form, isLoading }) {
  return (
    <Card
      id="card-export-translation-exportOptions"
      // cardStyle="positive"
      roundedBorder
      headerStart={
        <div className={css.cardHeader}>
          <Icon icon="lightning">
            <FormattedMessage
              id="ui-plugin-inventory-templates.barcodeGeneralSettings.generatorCard.label"
              defaultMessage="Generator settings"
            />
          </Icon>
        </div>
      }
      headerEnd={
        <>
          <Button
            disabled={pristine || submitting}
            id="default-fields-form-pane-footer-submit-btn"
            marginBottom0
            type="submit"
            onClick={() => form.reset()}
            onMouseDown={(e) => e.preventDefault()}
          >
            <FormattedMessage
              id="stripes-components.cancel"
              defaultMessage="Cancel"
            />
          </Button>
          <Button
            buttonStyle="primary"
            disabled={pristine || submitting}
            id="default-fields-form-pane-footer-submit-btn"
            marginBottom0
            type="submit"
            onMouseDown={(e) => e.preventDefault()}
          >
            <FormattedMessage
              id="stripes-core.button.save"
              defaultMessage="Save"
            />
          </Button>
        </>
      }
    >
      {isLoading && <Loading />}
      {!isLoading && (
        <>
          <Row>
            <Col xs={12}>
              <Field
                id="enableGenerator"
                name="enableGenerator"
                component={Checkbox}
                fullWidth
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.barcode.general.settings.generatorCard.fields.enableGenerator"
                    defaultMessage="Enable barcode generator"
                  />
                }
                type="checkbox"
                onMouseDown={(e) => e.preventDefault()}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <Field
                id="autoGenerate"
                name="autoGenerate"
                component={Checkbox}
                fullWidth
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.barcode.general.settings.generatorCard.fields.autoGenerate"
                    defaultMessage="Auto generate"
                  />
                }
                type="checkbox"
                onMouseDown={(e) => e.preventDefault()}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <Field
                id="showBarcodeLabel"
                name="showBarcodeLabel"
                component={Checkbox}
                fullWidth
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.barcode.general.settings.generatorCard.fields.showBarcodeLabel"
                    defaultMessage="Show barcode label"
                  />
                }
                type="checkbox"
                onMouseDown={(e) => e.preventDefault()}
              />
            </Col>
          </Row>
        </>
      )}
    </Card>
  );
}

GeneratorCard.propTypes = {
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  form: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default GeneratorCard;
